import React, { useState, useEffect } from "react";
import { Tabs, Spin } from "antd";
import FirmUser from "./FirmUser";
import FirmParameter from "./FirmParameter";
import PaymentSet from "./PaymentSet";
import SubFirm from "./SubFirm";
import RequestHandler from "./../../util/RequestHandler";
import PaymentMethod from "./PaymentMethod";
const { TabPane } = Tabs;

const FirmPanel = () => {
  const [activeKey, setActiveKey] = useState(null);
  const [spinning, setSpinning] = useState(true);
  const [lastSetTime, setLastSetTime] = useState(0);
  const [usePaymentMethodTab, setUsePaymentMethodTab] = useState(false);

  useEffect(() => {
    const checkPermissions = async () => {
      try {
        const response = await RequestHandler.get("/User/MenuPermissions", {
          userId: localStorage.getItem("userId"),
        });

        const tenantParameterResponse = await RequestHandler.get(
          "/TenantParameter/GetByTenant"
        );
        setUsePaymentMethodTab(
          tenantParameterResponse?.isPosTransactionUseAdditionalField
        );

        if (
          response.isAdmin === true ||
          response.isFullPageAuth === true ||
          response.isB2bAdmin === true
        ) {
          const now = Date.now();
          setLastSetTime(now);
          setActiveKey("1");
        } else {
          const res = await RequestHandler.post(
            "/User/RoleList",
            {
              UserId: localStorage.getItem("userId"),
            },
            false
          );

          let b2bRoles = res.data.filter((x) => x.moduleId === 8);

          if (
            b2bRoles.some(
              (x) =>
                x.controllerName === "TenantFirmUser" && x.isActive === true
            )
          ) {
            const now = Date.now();
            setLastSetTime(now);
            setActiveKey("1");
          } else if (
            b2bRoles.some(
              (x) => x.controllerName === "PaymentSet" && x.isActive === true
            )
          ) {
            const now = Date.now();
            setLastSetTime(now);
            setActiveKey("4");
          } else if (
            b2bRoles.some(
              (x) => x.controllerName === "FirmParameter" && x.isActive === true
            )
          ) {
            const now = Date.now();
            setLastSetTime(now);
            setActiveKey("3");
          } else if (
            b2bRoles.some(
              (x) => x.controllerName === "SubFirm" && x.isActive === true
            )
          ) {
            const now = Date.now();
            setLastSetTime(now);
            setActiveKey("2");
          } else if (
            tenantParameterResponse?.isPosTransactionUseAdditionalField === true
          ) {
            const now = Date.now();
            setLastSetTime(now);
            setActiveKey("5");
          }
        }
      } catch (error) {
      } finally {
        setSpinning(false);
        if (activeKey === null) {
          const now = Date.now();
          setLastSetTime(now);
          setActiveKey("1");
        }
      }
    };

    checkPermissions();
  }, []);

  useEffect(() => {
    if (activeKey !== null) {
      const now = Date.now();
      if (now >= lastSetTime) {
        setActiveKey(activeKey);
      }
    }
  }, [activeKey, lastSetTime]);

  return (
    <>
      <Spin spinning={spinning}>
        <Tabs
          activeKey={activeKey}
          onChange={(key) => {
            setActiveKey(key);
          }}
        >
          <TabPane tab="Firma Tanımları" key="1">
            <FirmParameter />
          </TabPane>
          <TabPane tab="Ödeme Setleri" key="2">
            <PaymentSet />
          </TabPane>
        </Tabs>
      </Spin>
    </>
  );
};

export default FirmPanel;
